import React, { useEffect } from "react";
import { Button, Modal, Spin, Table } from "antd";
import { useQuestionModal } from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/useQuestionModal";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import {
  getLod1,
  handleRowSelect,
  handleSelectAll,
} from "utilFunctions/helperFunctions/utilFunctions";
import QuestionModalInfo from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/QuestionModalInfo";

/* -------------------- PROPS -------------------- */
interface PickQuestionsTableProps {
  data?: any[];
  pagination?: any;
  loading?: boolean;
  onSelectChange?: (rows: any[]) => void;
  onPageChange?: (pagination: any) => void;
  qIdKey?: any[];
  setQIdKey?: React.Dispatch<React.SetStateAction<any[]>>;
  scroll?: any;
  disabledKeys?: any;
  checked?: boolean;
  handleAction?: any;
}

/* -------------------- COMPONENT -------------------- */
const PickQuestionsTable: React.FC<PickQuestionsTableProps> = ({
  data = [],
  pagination,
  loading = false,
  onSelectChange,
  onPageChange,
  qIdKey = [],
  setQIdKey,
  scroll = { x: "max-content" },
  disabledKeys = [],
  checked = false,
  handleAction,
}) => {
  const {
    fetchQuestion,
    modalQuestion,
    showQuestionModal,
    setShowQuestionModal,
    apiloader,
  } = useQuestionModal();
  const { question } = modalQuestion || {};
  const { defaultQuestionLanguage } = question || {};
  const columns: any[] = [
    {
      title: "Question",
      dataIndex: "questionText",
      key: "questionText",
      width: 800,
      render: (_: any, record: any) => {
        const { questionText, questionId } = record;
        return (
          <div
            className="questiontexttableColumn"
            dangerouslySetInnerHTML={{ __html: questionText }}
            style={{
              width: "800px",
            }}
            onClick={() =>
              fetchQuestion(
                BASE_URL + "questionLanguage?questionId=" + questionId,
                { question: { ...record } }
              )
            }
          />
        );
      },
    },
    {
      title: "LOD",
      dataIndex: "lod1",
      key: "lod1",
      render: (lod1: any) => <>{(lod1 && getLod1(lod1)) || "N/A"}</>,
    },
    {
      title: "Type",
      dataIndex: "questionType",
      key: "questionType",
    },
    ...(handleAction
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: any) => (
              <Button type="text" danger onClick={() => handleAction(record)}>
                Remove
              </Button>
            ),
          },
        ]
      : []),
  ];

  const rowSelection = {
    selectedRowKeys: qIdKey.map((ele: any) => ele.questionId),
    onSelect: (record: any, selected: boolean, selectedRows: any) =>
      setQIdKey && handleRowSelect(record, selected, selectedRows, setQIdKey),
    onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) =>
      setQIdKey &&
      handleSelectAll(selected, selectedRows, changeRows, setQIdKey),
    getCheckboxProps: (record: any) => {
      const isAny = disabledKeys.some(
        (ele: string) => ele == record.questionId
      );
      console.log("recordrecord", record, disabledKeys, isAny);
      return {
        disabled: isAny ? true : false,
      };
    },
  };

  useEffect(() => {
    onSelectChange?.(qIdKey);
  }, [qIdKey]);

  const handleTableChange = (pagination: any) => {
    onPageChange?.(pagination);
  };
  return (
    <>
      <Modal
        loading={apiloader}
        width={1000}
        open={showQuestionModal}
        footer={false}
        centered
        closable={true}
        onCancel={() => {
          setShowQuestionModal(false);
        }}
      >
        {apiloader ? (
          <div className="mx-auto text-center py-5 my-5">
            <Spin></Spin>
          </div>
        ) : (
          <QuestionModalInfo question={defaultQuestionLanguage} />
        )}
      </Modal>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="questionId"
        rowSelection={checked ? undefined : rowSelection}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={scroll}
        size="small"
        bordered
      />
    </>
  );
};

export default PickQuestionsTable;
